module.exports = __webpack_public_path__ + "static/media/Port-Autonomy.837506da.png";